import { ActionReducer } from '@ngrx/store';

import { BuildingsEffects } from '@store/buildings/buildings.effects';
import { buildingsReducer } from '@store/buildings/buildings.reducer';
import { BuildingsState } from '@store/buildings/buildinngs.state';
import { DeviceModelsEffects } from '@store/deviceModels/device_models.effects';
import { deviceModelsReducer, DeviceModelsState } from '@store/deviceModels/device_models.reducer';
import { DriversEffects } from '@store/drivers/drivers.effects';
import { driversReducer } from '@store/drivers/drivers.reducer';
import { DriversState } from '@store/drivers/drivers.state';
import { DriversGroupsEffects } from '@store/driversGroups/driversGroups.effects';
import { driversGroupsReducer } from '@store/driversGroups/driversGroups.reducer';
import { DriversGroupsState } from '@store/driversGroups/driversGroups.state';
import { AddressEffects } from '@store/effects/address.effects';
import { CurrentUserEffects } from '@store/effects/current_user.effects';
import { DeviceEffects } from '@store/effects/devices.effects';
import { ImportObjectsEffects } from '@store/effects/import_objects.effects';
import { ObjectGroupsEffects } from '@store/effects/object-groups.effects';
import { ObjectsEffects } from '@store/effects/objects.effects';
import { GeozonesGroupsEffects } from '@store/geozoneGroups/geozoneGroups.effects';
import { geozonesGroupsReducer } from '@store/geozoneGroups/geozoneGroups.reducer';
import { GeozoneGroupsState } from '@store/geozoneGroups/geozoneGroups.state';
import { GeozonesEffects } from '@store/geozones/geozones.effects';
import { geozonesReducer, GeozonesState } from '@store/geozones/geozones.reducer';
import { MailingReportsEffects } from '@store/mailingReports/mailingReports.effects';
import { mailingReportsReducer } from '@store/mailingReports/mailingReports.reducer';
import { MailingReportsState } from '@store/mailingReports/mailingReports.state';
import { MonitoringEffects } from '@store/monitoring/monitoring.effects';
import { monitoringReducer } from '@store/monitoring/monitoring.reducer';
import { MonitoringState } from '@store/monitoring/monitoring.state';
import { NotificationsEffects } from '@store/notifications/notifications.effects';
import { notificationsReducer } from '@store/notifications/notifications.reducer';
import { NotificationsState } from '@store/notifications/notifications.state';
import { addressReducer } from '@store/reducers/address.reducer';
import { currentUserReducer } from '@store/reducers/current_user.reducer';
import { deviceReducer } from '@store/reducers/devices.reducer';
import { importObjectsReducer } from '@store/reducers/import_objects.reducer';
import { messagesReducer, MessagesState } from '@store/reducers/messages.reducer';
import { objectGroupsReducer } from '@store/reducers/object-groups.reducer';
import { objectsReducer, ObjectsState } from '@store/reducers/objects.reducer';
import { tracksReducer, TracksState } from '@store/reducers/tracks.reducer';
import { usersReducer, UsersState } from '@store/reducers/users.reducer';
import { ReportsEffects } from '@store/reports/reports.effects';
import { reportsReducer } from '@store/reports/reports.reducer';
import { ReportsState } from '@store/reports/reports.state';
import { AddressState } from '@store/state/address.state';
import { DeviceState } from '@store/state/devices.state';
import { ObjectGroupsState } from '@store/state/object-groups.state';
import { TrailersEffects } from '@store/trailers/trailers.effects';
import { trailersReducer } from '@store/trailers/trailers.reducer';
import { TrailersState } from '@store/trailers/trailers.state';

export interface StateType {
  objects: ActionReducer<ObjectsState>;
  objectGroups: ActionReducer<ObjectGroupsState>;
  monitoring: ActionReducer<MonitoringState>;
  address: ActionReducer<AddressState>;
  geozones: ActionReducer<GeozonesState>;
  geozonesGroups: ActionReducer<GeozoneGroupsState>;
  deviceModels: ActionReducer<DeviceModelsState>;
  currentUser: ActionReducer<any>;
  notifications: ActionReducer<NotificationsState>;
  drivers: ActionReducer<DriversState>;
  driversGroups: ActionReducer<DriversGroupsState>;
  buildings: ActionReducer<BuildingsState>;
  importObjects: ActionReducer<any>;
  users: ActionReducer<UsersState>;
  devices: ActionReducer<DeviceState>;
  tracks: ActionReducer<TracksState>;
  messages: ActionReducer<MessagesState>;
  reports: ActionReducer<ReportsState>;
  mailingReports: ActionReducer<MailingReportsState>;
  trailers: ActionReducer<TrailersState>;
  // trailerGroups: ActionReducer<TrailerGroupsState>;
}

export const mainReducers: StateType = {
  address: addressReducer,
  objects: objectsReducer,
  objectGroups: objectGroupsReducer,
  monitoring: monitoringReducer,
  geozones: geozonesReducer,
  geozonesGroups: geozonesGroupsReducer,
  deviceModels: deviceModelsReducer,
  currentUser: currentUserReducer,
  notifications: notificationsReducer,
  drivers: driversReducer,
  driversGroups: driversGroupsReducer,
  buildings: buildingsReducer,
  importObjects: importObjectsReducer,
  users: usersReducer,
  devices: deviceReducer,
  messages: messagesReducer,
  reports: reportsReducer,
  mailingReports: mailingReportsReducer,
  tracks: tracksReducer,
  trailers: trailersReducer,
};

export const rootEffects = [
  ObjectsEffects,
  ObjectGroupsEffects,
  MonitoringEffects,
  DeviceModelsEffects,
  CurrentUserEffects,
  GeozonesEffects,
  NotificationsEffects,
  DriversEffects,
  DriversGroupsEffects,
  BuildingsEffects,
  ImportObjectsEffects,
  AddressEffects,
  DeviceEffects,
  TrailersEffects,
  ReportsEffects,
  MailingReportsEffects,
  GeozonesGroupsEffects,
];
